
// import { render } from '@wordpress/element';
// import {TabPanes} from './components/TabPanes'

window.addEventListener('DOMContentLoaded', (event) => {
    // const wrappers = document.getElementsByClassName(`tab-panes-wrapper`);

    // for(let wrapper of wrappers) {
        
    //     render(<TabPanes/>, wrapper);
    // }
    function setupTabs (){
        document.querySelectorAll('.tab-content').forEach((contentPane, index) => {
            // Add the incremental data-tab attribute
            if(index == 0){
                contentPane.classList.add('tab-content-active')
            }
            contentPane.setAttribute('data-tab', index + 1); // Index starts at 0, so add 1
        });
        

        document.querySelectorAll('.tab-btn').forEach((button, index) => {
          button.addEventListener('click',()=>{
            
            
            const sidebar = button.parentElement;
            const tabs = sidebar.parentElement;
            const tabNumber = button.dataset.forTab;
            const tabActivate = tabs.querySelector(`.tab-content[data-tab="${tabNumber}"]`)
            
            sidebar.querySelectorAll('.tab-btn').forEach(button=>{
              button.classList.remove('tab-btn-active')
            })
             tabs.querySelectorAll('.tab-content').forEach(tab=>{
              tab.classList.remove('tab-content-active')
            })
            button.classList.add('tab-btn-active')
            tabActivate.classList.add('tab-content-active')
          })
        })
      }
      
    setupTabs();
});